<script setup lang="ts">
import { reactive, ref } from 'vue'
import formBaseSearchItem from './form-base-search-item.vue'

defineOptions({
  name: 'formBaseSearch',
})

const clickNum = ref(0)
const visible = ref(false)

const list = [
  {
    fieldName: 'birthday',
    fieldType: 'java.time.LocalDate',
    supportedOperators: [
      'EQ',
      'GT',
      'GE',
      'LT',
      'LE',
      'BETWEEN',
      'NOT_BETWEEN',
    ],
    enabled: true,
    priority: 20,
    description: '出生日期',
  },
  {
    fieldName: 'lastLogin',
    fieldType: 'java.time.LocalDateTime',
    supportedOperators: [
      'EQ',
      'GT',
      'GE',
      'LT',
      'LE',
      'BETWEEN',
      'NOT_BETWEEN',
    ],
    enabled: true,
    priority: 20,
    description: '上次登录时间',
  },
  {
    fieldName: 'education',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '学历',
  },
  {
    fieldName: 'gender',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '性别',
  },
  {
    fieldName: 'timezone',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '时区',
  },
  {
    fieldName: 'extJson',
    fieldType: 'java.lang.Object',
    supportedOperators: ['EQ', 'NE'],
    enabled: true,
    priority: 20,
    description: '扩展字段(JSON格式)',
  },
  {
    fieldName: 'remark',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '备注',
  },
  {
    fieldName: 'language',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '语言偏好',
  },
  {
    fieldName: 'enabled',
    fieldType: 'java.lang.Boolean',
    supportedOperators: ['EQ', 'NE'],
    enabled: true,
    priority: 20,
    description: '是否启用',
  },
  {
    fieldName: 'lastLoginIp',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '登录IP',
  },
  {
    fieldName: 'registerSource',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '注册来源',
  },
  {
    fieldName: 'securityLevel',
    fieldType: 'java.lang.Integer',
    supportedOperators: ['EQ', 'GT', 'GE', 'LT', 'LE', 'BETWEEN'],
    enabled: true,
    priority: 20,
    description: '安全等级',
  },
  {
    fieldName: 'score',
    fieldType: 'java.lang.Integer',
    supportedOperators: ['EQ', 'GT', 'GE', 'LT', 'LE', 'BETWEEN'],
    enabled: true,
    priority: 20,
    description: '分数',
  },
  {
    fieldName: 'twoFactorEnabled',
    fieldType: 'java.lang.Boolean',
    supportedOperators: ['EQ', 'NE'],
    enabled: true,
    priority: 20,
    description: '双因子认证',
  },
  {
    fieldName: 'province',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'IN', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '省份',
  },
  {
    fieldName: 'nickname',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '昵称',
  },
  {
    fieldName: 'passed',
    fieldType: 'java.lang.Boolean',
    supportedOperators: ['EQ', 'NE'],
    enabled: true,
    priority: 20,
    description: '是否通过',
  },
  {
    fieldName: 'id',
    fieldType: 'java.lang.Long',
    supportedOperators: ['EQ', 'GT', 'GE', 'LT', 'LE', 'BETWEEN'],
    enabled: true,
    priority: 20,
    description: '主键ID',
  },
  {
    fieldName: 'email',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '电子邮箱',
  },
  {
    fieldName: 'loginChannel',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '登录渠道',
  },
  {
    fieldName: 'accessLevel',
    fieldType: 'java.lang.Integer',
    supportedOperators: ['EQ', 'GT', 'GE', 'LT', 'LE', 'BETWEEN'],
    enabled: true,
    priority: 20,
    description: '访问级别',
  },
  {
    fieldName: 'lastModifiedDate',
    fieldType: 'java.time.LocalDateTime',
    supportedOperators: [
      'EQ',
      'GT',
      'GE',
      'LT',
      'LE',
      'BETWEEN',
      'NOT_BETWEEN',
    ],
    enabled: true,
    priority: 20,
    description: '最后修改时间',
  },
  {
    fieldName: 'avatarUrl',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '头像URL',
  },
  {
    fieldName: 'retryCount',
    fieldType: 'java.lang.Integer',
    supportedOperators: ['EQ', 'GT', 'GE', 'LT', 'LE', 'BETWEEN'],
    enabled: true,
    priority: 20,
    description: '登录失败次数',
  },
  {
    fieldName: 'phoneVerified',
    fieldType: 'java.lang.Boolean',
    supportedOperators: ['EQ', 'NE'],
    enabled: true,
    priority: 20,
    description: '手机是否验证',
  },
  {
    fieldName: 'lastModifiedBy',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '最后修改人',
  },
  {
    fieldName: 'active',
    fieldType: 'java.lang.Boolean',
    supportedOperators: ['EQ', 'NE'],
    enabled: true,
    priority: 20,
    description: '是否激活',
  },
  {
    fieldName: 'version',
    fieldType: 'java.lang.Integer',
    supportedOperators: ['EQ', 'GT', 'GE', 'LT', 'LE', 'BETWEEN'],
    enabled: true,
    priority: 20,
    description: '乐观锁',
  },
  {
    fieldName: 'loginCount',
    fieldType: 'java.lang.Integer',
    supportedOperators: ['EQ', 'GT', 'GE', 'LT', 'LE', 'BETWEEN'],
    enabled: true,
    priority: 20,
    description: '登录次数',
  },
  {
    fieldName: 'tags',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '标签',
  },
  {
    fieldName: 'passwordUpdatedAt',
    fieldType: 'java.time.LocalDateTime',
    supportedOperators: [
      'EQ',
      'GT',
      'GE',
      'LT',
      'LE',
      'BETWEEN',
      'NOT_BETWEEN',
    ],
    enabled: true,
    priority: 20,
    description: '密码更新时间',
  },
  {
    fieldName: 'emailVerified',
    fieldType: 'java.lang.Boolean',
    supportedOperators: ['EQ', 'NE'],
    enabled: true,
    priority: 20,
    description: '邮箱是否验证',
  },
  {
    fieldName: 'realName',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '真实姓名',
  },
  {
    fieldName: 'createdDate',
    fieldType: 'java.time.LocalDateTime',
    supportedOperators: [
      'EQ',
      'GT',
      'GE',
      'LT',
      'LE',
      'BETWEEN',
      'NOT_BETWEEN',
    ],
    enabled: true,
    priority: 20,
    description: '创建时间',
  },
  {
    fieldName: 'createdBy',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '创建人',
  },
  {
    fieldName: 'phone',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '手机号',
  },
  {
    fieldName: 'grade',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '年级',
  },
  {
    fieldName: 'tenantId',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '租户ID',
  },
  {
    fieldName: 'idCardNumber',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '身份证号',
  },
  {
    fieldName: 'lastLoginDevice',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '登录设备',
  },
  {
    fieldName: 'userType',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '用户类型',
  },
  {
    fieldName: 'passwordExpired',
    fieldType: 'java.lang.Boolean',
    supportedOperators: ['EQ', 'NE'],
    enabled: true,
    priority: 20,
    description: '密码是否过期',
  },
  {
    fieldName: 'region',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '地区',
  },
  {
    fieldName: 'age',
    fieldType: 'java.lang.Integer',
    supportedOperators: ['EQ', 'GT', 'GE', 'LT', 'LE', 'BETWEEN'],
    enabled: true,
    priority: 20,
    description: '年龄',
  },
  {
    fieldName: 'status',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '状态',
  },
  {
    fieldName: 'username',
    fieldType: 'java.lang.String',
    supportedOperators: ['EQ', 'LIKE', 'LIKE_LEFT', 'LIKE_RIGHT'],
    enabled: true,
    priority: 20,
    description: '用户名',
  },
]

let searchList = reactive<any>([])

// const searchList = reactive<any>([
//   {
//     checkboxValue: true,
//     level: 0,
//     fieldName: "project",
//   },
//   {
//     checkboxValue: true,
//     level: 0,
//     fieldName: "project",
//   },
//   {
//     checkboxValue: true,
//     level: 0,
//     fieldName: "project2",
//     isGroup: true,
//     children: [
//       {
//         checkboxValue: true,
//         level: 1,
//         fieldName: "project2-1",
//       },
//       {
//         checkboxValue: true,
//         level: 1,
//         fieldName: "project2-1",
//       }
//     ]
//   },
//   {
//     checkboxValue: true,
//     level: 0,
//     fieldName: "project3",
//     isGroup: true,
//     children: [
//       {
//         checkboxValue: true,
//         level: 1,
//         fieldName: "project3-1",
//       },
//       {
//         checkboxValue: true,
//         level: 1,
//         fieldName: "project3-3",
//       },
//       {
//         checkboxValue: true,
//         level: 1,
//         isGroup: true,
//         fieldName: "project3-2",
//         children: [
//           {
//             checkboxValue: true,
//             level: 2,
//             fieldName: "project3-2-1",
//           }
//         ]
//       }
//     ]
//   },
//   {
//     checkboxValue: true,
//     level: 0,
//     fieldName: "project4",
//     isGroup: true,
//     children: [
//       {
//         checkboxValue: true,
//         level: 1,
//         fieldName: "project4-1",
//       },
//       {
//         checkboxValue: true,
//         level: 1,
//         isGroup: true,
//         fieldName: "project4-1",
//         children: [
//           {
//             checkboxValue: true,
//             level: 2,
//             fieldName: "project4-1-1",
//           },
//           {
//             checkboxValue: true,
//             level: 2,
//             isGroup: true,
//             fieldName: "project4-1-1",
//             children: [
//                 {
//                 checkboxValue: true,
//                 level: 3,
//                 fieldName: "project4-1-1",
//               }
//             ]
//           }
//         ]
//       }
//     ]
//   },
// ])

const state1 = list.map((item) => item.fieldName)

const methods = {
  handleClickAdd(item: any) {
    clickNum.value++
    if (Object.keys(item).length > 0) {
      if (item.level === 0) {
        searchList.push({
          checkboxValue: true,
          level: 0,
          pid: item.uid,
          uid: methods.generateUUID(),
          fieldName: state1[clickNum.value % state1.length],
        })
      } else {
        const pNode = methods.flat(searchList, item.pid)
        pNode.children.push({
          checkboxValue: true,
          level: pNode.level + 1,
          pid: pNode.uid,
          uid: methods.generateUUID(),
          fieldName: state1[clickNum.value % state1.length],
        })
      }
    } else {
      searchList.push({
        checkboxValue: true,
        level: 0,
        pid: 0,
        uid: methods.generateUUID(),
        fieldName: state1[clickNum.value % state1.length],
      })
    }
  },
  handleClickGroup(item: any) {
    clickNum.value++
    if (Object.keys(item).length > 0) {
      if (item.level === 0) {
        const id = methods.generateUUID()
        searchList.push({
          checkboxValue: true,
          level: 0,
          isGroup: true,
          uid: id,
          pid: item.uid,
          children: [
            {
              checkboxValue: true,
              level: 1,
              pid: id,
              uid: methods.generateUUID(),
              fieldName: state1[clickNum.value % state1.length],
            },
          ],
        })
      } else {
        const pNode = methods.flat(searchList, item.pid)
        const id = methods.generateUUID()
        pNode.children.push({
          checkboxValue: true,
          level: pNode.level + 1,
          uid: id,
          pid: pNode.uid,
          isGroup: true,
          children: [
            {
              checkboxValue: true,
              uid: methods.generateUUID(),
              pid: id,
              level: pNode.level + 2,
              fieldName: state1[clickNum.value % state1.length],
            },
          ],
        })
      }
    } else {
      const id = methods.generateUUID()
      searchList.push({
        checkboxValue: true,
        level: 0,
        uid: id,
        pid: 0,
        isGroup: true,
        children: [
          {
            checkboxValue: true,
            level: 1,
            pid: id,
            uid: methods.generateUUID(),
            fieldName: state1[clickNum.value % state1.length],
          },
        ],
      })
    }
  },
  add(item: any) {
    methods.handleClickAdd(item)
  },
  group(item: any) {
    methods.handleClickGroup(item)
  },
  hanldeCheckbox(item: any) {
    const fn = (data: any) => {
      data.forEach((k: any) => {
        k.checkboxValue = item.checkboxValue
        if (k.children && k.children.length > 0) {
          fn(k.children)
        }
      })
    }
    if (item.children) {
      fn(item.children)
    }
  },
  handleClear() {
    clickNum.value = 0
    searchList.length = 0
  },
  generateUUID() {
    const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    return template.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  },
  flat(arr: any, pid: any): any {
    for (let node of arr) {
      if (node.uid === pid) {
        return node // 找到匹配的节点，返回它
      } else if (node.children) {
        const found = methods.flat(node.children, pid) // 递归查找子节点
        if (found) {
          return found // 如果在子节点中找到，返回它
        }
      }
    }
    return null // 如果没有找到，返回null
  },
}
</script>

<template>
  <el-popover
    placement="bottom-start"
    :width="800"
    trigger="click"
    :visible="visible"
  >
    <div style="display: flex; height: 100%">
      <div style="flex: 1; height: 100%">
        <div>
          <el-button text @click="methods.handleClear">清空</el-button>
        </div>
        <div class="form-base-search">
          <template v-if="searchList.length > 0">
            <formBaseSearchItem
              v-for="(item, index) in searchList"
              :key="index"
              :item-data="item"
              @add="methods.add"
              @group="methods.group"
              @changeCheckbox="methods.hanldeCheckbox"
              :state1="state1"
              :dataList="list"
            ></formBaseSearchItem>
          </template>
          <template v-else>
            <div class="form-base-search-item">
              <div class="form-base-search-item-top">
                <div
                  class="form-base-search-item-btn"
                  @click="methods.handleClickAdd({})"
                >
                  +
                </div>
                <div
                  class="form-base-search-item-btn"
                  @click="methods.handleClickGroup({})"
                >
                  <span>()</span>
                  <span>+</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div style="width: 400px; height: 480px; overflow: auto">
        <pre>{{ searchList }}</pre>
      </div>
    </div>
    <template #reference>
      <el-button @click="visible = !visible">筛选</el-button>
    </template>
  </el-popover>
</template>
